<script lang="ts">
	import { getContext } from 'svelte';
	import DefaultNumberInput from '../../input/DefaultNumberInput.svelte';
	import {
		buildFilterValue,
		FilterCondition,
		type FilterOption,
		type SimpleListContext
	} from '../../../types/ListTypes';
	import DefaultFilterType from './DefaultFilterType.svelte';

	const { updateFilterActivityState } = getContext<SimpleListContext>('enzianListContext');

	interface Props {
		id?: string;
		hasFilter?: boolean;
		filterOption: FilterOption;
	}

	let { id = undefined, hasFilter = false, filterOption = $bindable() }: Props = $props();

	async function handleValueChange(e: any) {
		//Get the big value
		const numberValue = e.value;

		if (numberValue != null) {
			//Update the external value.
			filterOption.value = buildFilterValue(numberValue, filterCondition);
			updateFilterActivityState();
		} else {
			//Update the external value.
			filterOption.value = null;
			updateFilterActivityState();
		}
	}

	function handleFilterChange() {
		let value = null;

		if (filterOption.value != null) {
			const values = filterOption.value.split('|');

			if (values.length >= 2 && values[0].length > 0 && values[0] != 'null') {
				value = parseFloat(values[0]);
			} else {
				value = null;
			}

			//Update the external value.
			filterOption.value = buildFilterValue(value, filterCondition);
			updateFilterActivityState();
		}
	}

	let filterCondition = $derived.by(() => {
		let rawValue = filterOption.value;
		//Read value back in.
		if (rawValue != null && rawValue != 'null') {
			const values = rawValue.split('|');
			//@ts-ignore
			return values.length >= 2 ? FilterCondition[values[1]] : FilterCondition.EQ;
		} else {
			return FilterCondition.EQ;
		}
	});

	let value = $derived.by(() => {
		let rawValue = filterOption.value;
		//Read value back in.
		if (rawValue != null && rawValue != 'null') {
			const values = rawValue.split('|');
			if (values.length >= 2 && values[0].length > 0 && values[0] != 'null') {
				return parseFloat(values[0]);
			} else {
				return null;
			}
		} else {
			//If the value is null reset
			return null;
		}
	});
</script>

<div class="grid grid-cols-[1fr_auto] items-center gap-2">
	<DefaultNumberInput
		{id}
		propertyName="value"
		{value}
		nullModus={true}
		callFunction={handleValueChange}
	/>
	{#if hasFilter}
		<DefaultFilterType onFilterTypeChange={handleFilterChange} bind:filterCondition />
	{/if}
</div>
